import { Tabs } from 'antd';

export const LCTabPane = Tabs.TabPane;
